import { plainToInstance, Type } from 'class-transformer'

import { TemplateFormAnswers } from '@core/entities/template/TemplateFormAnswers'
import { Entity } from '@core/entities/entity'
import { IChecklistApproval } from '@core/entities/checklist/ChecklistApproval/IChecklistApproval'
import { TemplateForm } from '@core/entities/template/TemplateForm'

export class ChecklistApproval extends Entity<IChecklistApproval> {
  id: string

  label: string

  allowDeletion?: boolean

  @Type(() => TemplateForm)
  approvalQuestions?: TemplateForm

  @Type(() => TemplateFormAnswers)
  approvalAnswers?: TemplateFormAnswers

  public static new(payload: unknown): ChecklistApproval {
    const entity = plainToInstance(ChecklistApproval, payload)

    return entity
  }
}
